var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.334,
    height: 40,
    viewBox: "0 0 48.334 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.bdskjfkdh1324pasfPsdf{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H40V40H0Z",
    transform: "translate(3.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bdskjfkdh1324pasfPsdf",
    d: "M23.834,21.334H22.517l-.467-.45a10.864,10.864,0,1,0-1.167,1.167l.45.467v1.317l7.083,7.083A1.756,1.756,0,1,0,30.9,28.434Zm-10,0a7.5,7.5,0,1,1,7.5-7.5A7.49,7.49,0,0,1,13.834,21.334Z",
    transform: "translate(-8 2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.46abf284.svg";
export { ForwardRef as ReactComponent };